import { JsonArray, JsonObject } from '@eagle/common';
import { AlertResponse } from '@eagle/core-data-types';
import { Card, styled } from '@ethings/ui-toolkit';
import { Box } from '@mui/material';
import { FC, type JSX } from 'react';
import { FlexBox } from '../flex-box';
import { AlertListItemMobile } from './alert-list-item-mobile';

interface LayoutMobileProps {
  alerts: AlertResponse[];
  isLoading: boolean;
  paginationComponent?: JSX.Element;
  showPerson: boolean;
  showThing: boolean;
  showAllButtonComponent?: JSX.Element;
}

interface StyledCardProps {
  isLoading: boolean;
}

const StyledCard = styled(Card)<StyledCardProps>(({ theme, isLoading }) => ({
  filter: isLoading ? 'blur(1px)' : '',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  width: '100%',
  overflow: 'visible',
}));

export const AlertsTableLayoutMobile: FC<LayoutMobileProps> = ({
  alerts,
  isLoading,
  paginationComponent,
  showPerson,
  showThing,
  showAllButtonComponent,
}): JSX.Element => {
  return (
    <FlexBox
      data-testid='alert-table'
      role='table'
      sx={{
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'auto',
        padding: 0,
      }}
    >
      {alerts.map((alert) => {
        const location = alert.data?.location as JsonObject;
        const address = (location && (location?.address as JsonArray)) || [];

        return (
          <StyledCard
            role='row'
            key={alert.alertId}
            isLoading={isLoading}
          >
            <AlertListItemMobile
              address={address}
              alert={alert}
              showPerson={showPerson}
              showThing={showThing}
            />
          </StyledCard>
        );
      })}
      {showAllButtonComponent ? <Box display='flex' justifyContent='center' marginTop={1} sx={{ mb: paginationComponent ? 1 : 3 }}> {showAllButtonComponent} </Box> : null}
      {paginationComponent
        ? <Box display="flex" justifyContent="center">
          {paginationComponent}
        </Box>
        : null
      }
    </FlexBox>
  );
};
